var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 35,
    viewBox: "0 0 254 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7133 1.20996C51.6362 1.4821 45.6762 6.10202 43.4258 12.4737H75.322C73.0716 6.10202 67.1107 1.4821 60.0345 1.20996H58.7133Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4228 12.4736C42.8003 14.2351 42.4609 16.1302 42.4609 18.1052C42.4609 20.0806 42.8003 21.9754 43.4228 23.7367H75.3191C75.9407 21.9754 76.28 20.0806 76.28 18.1052C76.28 16.1302 75.9407 14.2351 75.3191 12.4736H43.4228Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4258 23.7368C45.6762 30.1097 51.6371 34.7285 58.7133 35.0008H60.0345C67.1107 34.7285 73.0716 30.1097 75.322 23.7368H43.4258Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.886 0.000976562C93.5473 0.000976562 85.9766 7.57168 85.9766 16.9107C85.9766 26.2496 93.5473 33.8204 102.886 33.8204C112.225 33.8204 119.796 26.2496 119.796 16.9107C119.796 7.57168 112.225 0.000976562 102.886 0.000976562Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9857 0.249023C96.9757 0.768891 94.2371 2.08539 91.9966 3.97358L99.9857 11.9631V0.249023ZM105.783 11.9625L113.772 3.97358C111.532 2.08594 108.794 0.769527 105.783 0.249023V11.9625ZM89.9476 6.02338C88.0602 8.26419 86.7426 11.0016 86.2227 14.0122H97.9367L89.9476 6.02338ZM86.2227 19.8094C86.7426 22.8199 88.0593 25.5579 89.9476 27.7989L97.9367 19.8094H86.2227ZM91.9966 29.8479C94.2371 31.7357 96.9757 33.0527 99.9857 33.5731V21.8585L91.9966 29.8479ZM105.783 33.5731C108.794 33.0527 111.531 31.7357 113.772 29.8479L105.783 21.8591V33.5731ZM115.822 27.7989C117.71 25.5579 119.026 22.8199 119.546 19.8094H107.832L115.822 27.7989ZM119.546 14.0122C119.026 11.0016 117.709 8.26419 115.821 6.02338L107.833 14.0122H119.546Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.277 4.61719C91.0429 4.8386 90.8152 5.06573 90.5938 5.30021L99.3051 14.0116H99.9884V13.3285L91.277 4.61719ZM99.306 19.8087L90.5938 28.52C90.8152 28.7545 91.042 28.9822 91.277 29.2036L99.9884 20.4917V19.8087H99.306ZM105.786 20.4923L114.497 29.2036C114.731 28.9822 114.959 28.7545 115.181 28.52L106.469 19.8087H105.786V20.4923ZM106.469 14.0116L115.181 5.30021C114.959 5.06573 114.731 4.8386 114.496 4.61719L105.786 13.328V14.0116H106.469Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.886 0.000976562C102.232 0.000976562 101.588 0.0398148 100.954 0.111683V14.978H86.0873C86.0147 15.6124 85.9766 16.2567 85.9766 16.9107C85.9766 17.5641 86.0147 18.2083 86.0873 18.8428H100.954V33.7096C101.588 33.7815 102.232 33.8204 102.886 33.8204C103.54 33.8204 104.184 33.7821 104.818 33.7096V18.8428H119.685C119.757 18.2083 119.796 17.5641 119.796 16.9107C119.796 16.2567 119.758 15.6124 119.685 14.978H104.818V0.111683C104.184 0.0392703 103.54 0.000976562 102.886 0.000976562Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.496 17.5706C129.768 24.6477 134.388 30.6077 140.76 32.8582V0.961914C134.388 3.21235 129.768 9.17327 129.496 16.2494V17.5706Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.758 32.8581C142.519 33.4806 144.414 33.82 146.389 33.82C148.364 33.82 150.26 33.4806 152.021 32.8581V0.961876C150.26 0.340285 148.364 0 146.389 0C144.414 0 142.519 0.340285 140.758 0.961876V32.8581Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.023 32.8582C158.395 30.6077 163.015 24.6468 163.287 17.5706V16.2494C163.015 9.17327 158.395 3.21235 152.023 0.961914V32.8582Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.052 1.20996C183.723 1.4821 177.55 6.10202 175.219 12.4737H208.254C205.923 6.10202 199.75 1.4821 192.422 1.20996H191.052Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.218 12.4736C174.574 14.2351 174.223 16.1302 174.223 18.1052C174.223 20.0802 174.574 21.9753 175.218 23.7368H208.253C208.898 21.9753 209.25 20.0802 209.25 18.1052C209.25 16.1302 208.898 14.2351 208.253 12.4736H175.218Z",
    fill: "#FFDA44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.219 23.7368C177.55 30.1092 183.723 34.7285 191.052 35.0006H192.422C199.75 34.7285 205.923 30.1092 208.254 23.7368H175.219Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.408 1.20996C229.332 1.48219 223.372 6.10193 221.121 12.4739H253.017C250.767 6.10193 244.806 1.48219 237.73 1.20996H236.408Z",
    fill: "#6DA544"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.118 12.4736C220.496 14.235 220.156 16.1306 220.156 18.1052C220.156 20.0806 220.496 21.9754 221.118 23.7367H253.014C253.636 21.9754 253.976 20.0806 253.976 18.1052C253.976 16.1306 253.636 14.235 253.014 12.4736H221.118Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.121 23.7368C223.372 30.1097 229.333 34.7285 236.408 35.0008H237.73C244.806 34.7285 250.767 30.1097 253.017 23.7368H221.121Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.156 18.766C220.428 25.843 225.048 31.803 231.42 34.0535V2.15723C225.048 4.40766 220.428 10.3686 220.156 17.4447V18.766Z",
    fill: "#A2001D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_2590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 34.001C25.6127 34.001 33 26.6137 33 17.501C33 8.38828 25.6127 1.00098 16.5 1.00098C7.3873 1.00098 0 8.38828 0 17.501C0 26.6137 7.3873 34.001 16.5 34.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7147 13.9141H18.5728L16.5019 10.3271L14.4311 13.9141H10.2891L12.3602 17.501L10.2891 21.088H14.4311L16.5019 24.6749L18.5728 21.088H22.7147L20.6436 17.501L22.7147 13.9141ZM19.0462 17.501L17.7741 19.7046H15.2298L13.9576 17.501L15.2298 15.2975H17.7741L19.0462 17.501ZM16.5019 13.0939L16.9754 13.914H16.0286L16.5019 13.0939ZM12.6854 15.2975H13.6323L13.1588 16.1176L12.6854 15.2975ZM12.6854 19.7046L13.1589 18.8845L13.6324 19.7046H12.6854ZM16.5019 21.9081L16.0285 21.088H16.9754L16.5019 21.9081ZM20.3184 19.7046H19.3715L19.845 18.8845L20.3184 19.7046ZM19.3715 15.2975H20.3184L19.8449 16.1176L19.3715 15.2975Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7712 4.58789H6.22906C4.72324 5.78723 3.43186 7.244 2.42188 8.89226H30.5784C29.5683 7.24407 28.2769 5.78723 26.7712 4.58789Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22906 30.4142H26.7711C28.2769 29.2149 29.5683 27.7581 30.5783 26.1099H2.42188C3.43192 27.7581 4.7233 29.2149 6.22906 30.4142Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_2590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0 1.00098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.c51ce9bcf5fd1a9c958df88ecd4ee0df.svg";
export { ForwardRef as ReactComponent };